import Vue from 'vue';
import CartItem from './CartItem.vue';
import Shipment from './Shipment';
import './money';

new Vue({
  el: '#cart',

  components: { 'cart-item': CartItem },

  mixins: [Shipment],

  data: window?.Contraversus?.cart || {},

  computed: {
    /**
     * Get the cart subtotal.
     *
     * @returns {number}
     */
    subtotal () {
      return this.items
        .map(item => item.quantity * (item.sale || item.price))
        .reduce((sum, total) => sum + total, 0);
    },

    /**
     * Get the cart total.
     *
     * @returns {number}
     */
    total () {
      return this.subtotal + this.fee;
    },
  },
});
